import { render, staticRenderFns } from "./AParagraphCanFold.vue?vue&type=template&id=a111f9f8&scoped=true"
import script from "./AParagraphCanFold.vue?vue&type=script&lang=ts"
export * from "./AParagraphCanFold.vue?vue&type=script&lang=ts"
import style0 from "./AParagraphCanFold.vue?vue&type=style&index=0&id=a111f9f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a111f9f8",
  null
  
)

export default component.exports